import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PROJECT_MANAGEMENT_URL } from '@insite-store360/shared';
import { Observable, catchError } from 'rxjs';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectManagementCityService {
  private readonly URL_PATH = `${PROJECT_MANAGEMENT_URL}/city`;

  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandlerService
  ) { }

  /**
   * Get all cities with pagination and filters
   * @param pageIndex Current page index (0-based)
   * @param pageSize Items per page
   * @param countryIds Array of country IDs to filter by
   * @param searchFilter Search term for city name or country name
   * @returns Observable with cities data and paginator info
   */
  public getAll(
    pageIndex: number,
    pageSize: number,
    countryIds?: number[],
    searchFilter?: string
  ): Observable<any> {
    let queryParams = new HttpParams()
      .set('pageIndex', pageIndex.toString())
      .set('pageSize', pageSize.toString());

    if (searchFilter) {
      queryParams = queryParams.set('searchFilter', searchFilter);
    }
    if (countryIds && countryIds.length > 0) {
      queryParams = queryParams.set('country', countryIds.join(','));
    }

    return this.http
      .get<any>(`${this.URL_PATH}/getAll`, { params: queryParams })
      .pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Create a new city
   * @param payload City data (name, countryId, status)
   */
  public save(payload: any): Observable<any> {
    return this.http
      .post<any>(`${this.URL_PATH}/save`, payload)
      .pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Update an existing city
   * @param payload City data including ID
   */
  public update(payload: any): Observable<any> {
    return this.http
      .put<any>(`${this.URL_PATH}/update`, payload)
      .pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Delete a city (soft delete)
   * @param id City ID
   */
  public delete(id: number): Observable<any> {
    return this.http
      .delete<any>(`${this.URL_PATH}/delete/${id}`)
      .pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get all active countries
   */
  public getAllCountries(): Observable<any> {
    return this.http
      .get<any>(`${this.URL_PATH}/getCountries`)
      .pipe(catchError(this.errorHandler.handleError));
  }
}
